module.exports = __webpack_public_path__ + "static/media/logo-small.54cd8d66.svg";